import { message } from 'antd';
import { getClosedFunnelDetail } from 'api/operation/closedFunnel';
import { useCallback, useEffect, useState } from 'react';
import { IClosedFunnelDetail } from 'types/operation';

const useGetClosedFunnelDetail = (funnelId?: string): [IClosedFunnelDetail | undefined, boolean, (id: string) => Promise<void>] => {
    const [data, setData] = useState<IClosedFunnelDetail | undefined>();
    const [loading, setLoading] = useState(false);

    const fetch = useCallback(async (id: string) => {
        if (!id) {
            return;
        }
        try {
            setLoading(true);
            const res = await getClosedFunnelDetail(id);
            if (res && !res.error) {
                setData(res?.data?.data);
            } else {
                message.error(res?.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (funnelId) {
            fetch(funnelId);
        }
    }, [fetch, funnelId]);

    return [data, loading, fetch];
};

export default useGetClosedFunnelDetail;
